import React, { useEffect, useRef, useState } from "react";
import AttachmentIcon from "../../../../assets/icons/attachment";
import SendMessageIcon from "../../../../assets/icons/senMessage";
import {
  StyledSendMessageFileInputContainer,
  StyledSendMessageFileInput,
  StyledSendMessageTextInputContainer,
  StyledSendMessageTextInput,
  StyledSendMessageButton,
  StyledSendMessageWrapper
} from "./SendMessage.component.style";

import { useChatContext } from "../../../../providers/Chat";

const SendMessage = () => {
  const { sendTextMessage, selectedChat } = useChatContext();

  const [textMessage, setTextMessage] = useState("");

  const sendMessage = () => {
    const trimmedTextMessage = textMessage.trim();
    if (trimmedTextMessage.length === 0) {
      return;
    }
    sendTextMessage(trimmedTextMessage);
    setTextMessage("");
  };

  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, [selectedChat]);

  const sendButtonNotAvailable = textMessage.trim().length === 0;
  return (
    <StyledSendMessageWrapper>
      <StyledSendMessageFileInputContainer>
        <StyledSendMessageFileInput id="file" type="file" />
        <label htmlFor="file">
          <AttachmentIcon />
        </label>
      </StyledSendMessageFileInputContainer>
      <StyledSendMessageTextInputContainer>
        <StyledSendMessageTextInput
          ref={inputRef}
          type="text"
          placeholder="Type here"
          value={textMessage}
          onChange={e => setTextMessage(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              sendMessage();
            }
          }}
        />
        <StyledSendMessageButton
          disabled={sendButtonNotAvailable}
          onClick={sendMessage}
        >
          <SendMessageIcon />
        </StyledSendMessageButton>
      </StyledSendMessageTextInputContainer>
    </StyledSendMessageWrapper>
  );
};

export default SendMessage;
